import React from "react";

import { FAQData } from "data/classes";

import { FaqItem } from "~/components/faq/FaqItem";

import * as styles from "./FaqSection.css";

export const FaqSection = ({ faqData }: { faqData: FAQData }): React.ReactElement => (
  <div className={styles.faqOuterContainer}>
    <h1 className={styles.faqTitle}>Frequently asked questions</h1>
    {faqData?.faq?.map((faqItem, index) => (
      <div key={index} className={styles.faqItemWrap}>
        <FaqItem {...faqItem} />
      </div>
    ))}
  </div>
);
